export default __webpack_public_path__ + "static/media/little-nicky.421b5c8a.jpg";